import {
  Home24Regular,
  Person24Regular,
  Search24Regular,
} from "@fluentui/react-icons";
import { RouteEnum } from "../../../contextApis/RouteContext";
import { NavItem } from "./Navigation.types";

export const publicNavItems: NavItem[] = [
  {
    icon: Home24Regular,
    label: "Home",
    route: RouteEnum.HOME,
  },
  {
    icon: Person24Regular,
    label: "Sign In",
    route: RouteEnum.SIGN_IN,
  },
];

export const privateNavItems: NavItem[] = [
  {
    icon: Home24Regular,
    label: "Home",
    route: RouteEnum.HOME,
  },
  {
    icon: Search24Regular,
    label: "Drayage Search",
    route: RouteEnum.DRAYAGE_SEARCH,
  },
  {
    icon: Search24Regular,
    label: "OTR Search",
    route: RouteEnum.OTR_SEARCH,
  },
];
